import { render } from "./KSFromFilter.vue?vue&type=template&id=24271ac4"
import script from "./KSFromFilter.vue?vue&type=script&lang=js"
export * from "./KSFromFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__